import { KeyIcon, TrashIcon } from "assets";
import { CustomTooltip, SmallScreenModel } from "components";
import { useState } from "react";
import { UserProps } from "../../store/actionType";
import HandleDeleteUser from "../manage_user/HandleDeleteUser";
import HandleResetPassword from "../manage_user/HandleResetPassword";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';
import HandleUpdateUserRole from "../manage_user/HandleUpdateUserRole";
import {  Edit3Icon } from "lucide-react";

const ActionButton: React.FC<{ items: UserProps }> = ({ items }) => {
  const [isUpdateRole, setUpdateRole] = useState(false);
  const [isEditModel, setEditModel] = useState(false);
  const [isDeleteModel, setDeleteModel] = useState(false);
  const { authUser, action, superAdmin } = useUser();
  
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_CMS_USER));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center">
          <CustomTooltip title="Update User Role" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setUpdateRole(true)}
            >
              <Edit3Icon className="size-4 " />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Change Password" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setEditModel(true)}
            >
              <KeyIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Delete" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setDeleteModel(true)}
            >
              <TrashIcon />
            </button>
          </CustomTooltip>
          {isUpdateRole && (
            <SmallScreenModel
              setShowModal={setUpdateRole}
              showModal={isUpdateRole}
            >
              <HandleUpdateUserRole closeModal={setUpdateRole} userData={items} />
            </SmallScreenModel>
          )}
          {isEditModel && (
            <SmallScreenModel
              setShowModal={setEditModel}
              showModal={isEditModel}
            >
              <HandleResetPassword closeModal={setEditModel} userData={items} />
            </SmallScreenModel>
          )}
          {isDeleteModel && (
            <SmallScreenModel
              setShowModal={setDeleteModel}
              showModal={isDeleteModel}
            >
              <HandleDeleteUser closeModal={setDeleteModel} userData={items} />
            </SmallScreenModel>
          )}
        </div>
      </>
    );
  return <></>;
};
export default ActionButton;
